import React from 'react';
import './Banner.css'

const Banner = ({ imgSrc, imgAlt }) => {
  return (
    <div className='banner'>
        <div className='banner__img'>
            <img src={imgSrc} alt={imgAlt} loading='lazy' />
        </div>
    </div>
  )
}

export default Banner
